<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="解绑提示"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="unBindRules"
      label-width="auto"
    >
      <el-form-item label="解绑原因">
        <el-radio-group v-model="unBindRadio">
          <el-radio :label="1">损坏</el-radio>
          <el-radio :label="2">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="unBindRadio === 2"
        label="解绑原因"
        prop="unBindRemark"
      >
        <el-input
          v-model="params.unBindRemark"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :style="{ width: '100%' }"
          placeholder="请输入解绑原因"
          type="textarea"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="unbindGet">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import maintainUnBindDevice from "@/maintain/api/device/charging-pile-manage/maintainUnBindDevice";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  name: "unBindDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    deviceId: Number,
  },
  watch: {
    deviceId(newValue) {
      this.params.deviceId = newValue;
    },
  },
  data() {
    const un = (rule, value, callback) => {
      if (this.unBindRadio === 2) {
        if (value === "" || value === undefined) {
          callback(new Error("请输入解绑原因"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      unBindRules: {
        unBindRemark: {
          required: true,
          validator: un,
        },
      },
      unBindRadio: 1,
      params: {
        deviceId: undefined,
        unBindRemark: undefined,
      },
    };
  },
  methods: {
    unbindGet() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          if (this.unBindRadio === 1) {
            this.params.unBindRemark = "损坏";
          }
          maintainUnBindDevice(this.params).then((res) => {
            this.resEditNoDialog({ res });
          });
        }
      });
    },
  },
};
</script>
